import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClaimGuard } from '@lsq-frontend/common-ui';
import { Routes } from '@lsq-frontend/common-ui';
import {
    customerAtlas,
    customerNode,
    customerReportsAtlas,
    customersAtlas,
    customersNode
} from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { OverviewByCustomerComponent } from './customer-detail/overview/overview-by-customer.component';
import { AgingByCustomerReportComponent } from './customer-detail/reports/aging/aging-by-customer.report.component';
import { CollectionsByCustomerReportComponent } from './customer-detail/reports/collections/collections-by-customer.report.component';
import { IneligiblesByCustomerReportComponent } from './customer-detail/reports/ineligibles/ineligibles-by-customer.component';
import { PurchasesByCustomerReportComponent } from './customer-detail/reports/purchases/purchases-by-customer.component';
import { CustomersComponent } from './customers.component';
import { NewCustomerCreditComponent } from './new-customer-credit/new-customer-credit.component';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';

export const customersRoutes: Routes = [
    {
        path: UiRoutes.Home,
        component: CustomersComponent,
        canActivate: [ClaimGuard],
        data: {
            title: customersNode.title,
            claims: customersNode.claims
        }
    },
    {
        path: customersAtlas.CUSTOMERS_REQUEST_CREDIT.path,
        component: NewCustomerCreditComponent,
        canActivate: [ClaimGuard],
        data: {
            title: customersAtlas.CUSTOMERS_REQUEST_CREDIT.title,
            claims: customersAtlas.CUSTOMERS_REQUEST_CREDIT.claims
        }
    },
    {
        path: customerNode.path,
        component: CustomerDetailComponent,
        children: [
            {
                path: customerAtlas.CUSTOMER_OVERVIEW.path,
                component: OverviewByCustomerComponent,
                canActivate: [ClaimGuard],
                data: {
                    title: customerAtlas.CUSTOMER_OVERVIEW.title,
                    claims: customerAtlas.CUSTOMER_OVERVIEW.claims
                }
            },
            {
                path: customerAtlas.CUSTOMER_REPORTS.path,
                children: [
                    {
                        path: customerReportsAtlas.CUSTOMER_AGING.path,
                        component: AgingByCustomerReportComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title: customerReportsAtlas.CUSTOMER_AGING.title,
                            claims: customerReportsAtlas.CUSTOMER_AGING.claims
                        }
                    },
                    {
                        path: customerReportsAtlas.CUSTOMER_COLLECTIONS.path,
                        component: CollectionsByCustomerReportComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title: customerReportsAtlas.CUSTOMER_COLLECTIONS.title,
                            claims: customerReportsAtlas.CUSTOMER_COLLECTIONS.claims
                        }
                    },
                    {
                        path: customerReportsAtlas.CUSTOMER_PURCHASES.path,
                        component: PurchasesByCustomerReportComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title: customerReportsAtlas.CUSTOMER_PURCHASES.title,
                            claims: customerReportsAtlas.CUSTOMER_PURCHASES.claims
                        }
                    },
                    {
                        path: customerReportsAtlas.CUSTOMER_INELIGIBLES.path,
                        component: IneligiblesByCustomerReportComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title: customerReportsAtlas.CUSTOMER_INELIGIBLES.title,
                            claims: customerReportsAtlas.CUSTOMER_INELIGIBLES.claims
                        }
                    }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(customersRoutes)],
    exports: [RouterModule]
})
export class CustomersRoutingModule {}
